/*
  JM ADDICT — Aba do carrinho (desktop + telemóvel)

  1) Qualquer link para o carrinho (header, menu móvel flutuante, grelhas) abre a aba
     em vez de ir para /cart.
  2) Qualquer "Add to cart" custom que dispare o evento `cart:updated`
     (jm-product-template, collection-geral, colecao-playerversion, jm-ultimate-sync-grid)
     faz a aba atualizar e abrir.
  3) <jm-cart-upsell>: produtos relacionados no fundo da aba, com escolha de tamanho
     e botão de adicionar.

  Só é carregado quando settings.cart_type == 'drawer' (ver layout/theme.liquid).
*/
(function () {
  'use strict';

  if (window.__jmCartDrawerBridge) return;
  window.__jmCartDrawerBridge = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var upsellCache = {};

  function cartPath() {
    var url = (window.routes && window.routes.cart_url) || ROOT + 'cart';
    try {
      return new URL(url, window.location.origin).pathname.replace(/\/$/, '');
    } catch (e) {
      return '/cart';
    }
  }

  function onCartPage() {
    return window.location.pathname.replace(/\/$/, '') === cartPath();
  }

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  /* ---------- contadores (header, menu móvel, grelhas) ---------- */
  function updateBadges(count) {
    if (count === null || count === undefined || isNaN(count)) return;
    var nodes = document.querySelectorAll(
      '.cart-count-bubble, .jm-cart-count-badge, #jm-cart-count, #header-sync-badge, #floating-sync-badge'
    );
    Array.prototype.forEach.call(nodes, function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function countFromSections(sections) {
    try {
      var html = sections && sections['cart-icon-bubble'];
      if (!html) return null;
      var el = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-count-bubble');
      return el ? parseInt(el.getAttribute('data-count'), 10) : null;
    } catch (e) {
      return null;
    }
  }

  /* ---------- atualizar + abrir a aba ---------- */
  var refreshing = false;

  function refreshAndOpen() {
    var drawer = getDrawer();
    if (!drawer || typeof drawer.renderContents !== 'function') {
      return;
    }
    if (refreshing) return;
    refreshing = true;

    fetch(ROOT + '?sections=' + encodeURIComponent(SECTIONS), { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('sections ' + res.status);
        return res.json();
      })
      .then(function (sections) {
        var count = countFromSections(sections);
        drawer.classList.toggle('is-empty', count === 0);
        drawer.renderContents({ sections: sections });
        updateBadges(count);
      })
      .catch(function () {
        // se algo falhar, o cliente continua a conseguir ver o carrinho
        window.location.href = (window.routes && window.routes.cart_url) || ROOT + 'cart';
      })
      .then(function () {
        setTimeout(function () {
          refreshing = false;
        }, 400);
      });
  }

  // Eventos disparados pelos botões "Add to cart" custom do tema
  document.addEventListener('cart:updated', function () {
    if (onCartPage()) {
      fetch(ROOT + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateBadges(cart.item_count); });
      return;
    }
    refreshAndOpen();
  });

  // Links para o carrinho (menu móvel, header, grelhas) abrem a aba
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest && e.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    if (link.id === 'cart-icon-bubble') return; // já tratado por assets/cart-drawer.js
    var url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (err) {
      return;
    }
    if (url.origin !== window.location.origin) return;
    if (url.pathname.replace(/\/$/, '') !== cartPath()) return;
    if (onCartPage()) return;
    var drawer = getDrawer();
    if (!drawer || typeof drawer.open !== 'function') return;
    e.preventDefault();
    drawer.open(link);
  });

  // Quando o último artigo é removido na aba, o Dawn só troca a lista: pedimos a aba completa
  // para mostrar o estado vazio (mensagem + sugestões).
  var emptyFetching = false;
  function ensureEmptyState(drawer) {
    if (emptyFetching || !drawer.classList.contains('is-empty') || drawer.querySelector('.jmc-empty')) return;
    if (typeof drawer.renderContents !== 'function') return;
    emptyFetching = true;
    fetch(ROOT + '?sections=' + encodeURIComponent(SECTIONS), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (countFromSections(sections) === 0) drawer.renderContents({ sections: sections });
      })
      .catch(function () {})
      .then(function () { setTimeout(function () { emptyFetching = false; }, 600); });
  }

  // Classe no <html> quando a aba está aberta (usada para esconder o menu móvel flutuante)
  function watchDrawerState() {
    var drawer = getDrawer();
    if (!drawer || !window.MutationObserver) return;
    var sync = function () {
      document.documentElement.classList.toggle('jm-cart-open', drawer.classList.contains('active'));
      ensureEmptyState(drawer);
    };
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  // Mantém o contador do cabeçalho da aba igual ao nº de artigos (quantidade alterada na aba)
  function watchCount() {
    var drawer = getDrawer();
    if (!drawer || !window.MutationObserver) return;
    var sync = function () {
      var promo = drawer.querySelector('.jmc-promo[data-count]');
      var pill = drawer.querySelector('.jmc-count');
      var n = promo && promo.getAttribute('data-count');
      if (pill && n && pill.textContent !== n) pill.textContent = n;
    };
    new MutationObserver(sync).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watchDrawerState(); watchCount(); });
  } else {
    watchDrawerState();
    watchCount();
  }

  /* ---------- <jm-cart-upsell> ---------- */
  function skeleton(title) {
    var card = '<div class="jmu__card jmu__card--skeleton"><span class="jmu__sk jmu__sk--img"></span><span class="jmu__sk"></span><span class="jmu__sk jmu__sk--short"></span></div>';
    return '<div class="jmu"><div class="jmu__head"><h3 class="jmu__title">' + (title || 'You may also like') + '</h3></div><div class="jmu__track">' + card + card + card + '</div></div>';
  }

  class JmCartUpsell extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.addEventListener('click', this._onClick.bind(this));
      this._load();
    }

    _load() {
      var self = this;
      var popular = this.getAttribute('data-mode') === 'popular';
      var productId = this.getAttribute('data-product-id');
      if (!productId && !popular) {
        this.hidden = true;
        return;
      }
      var key = popular ? 'popular' : productId + '|' + (this.getAttribute('data-in-cart') || '');
      if (upsellCache[key] !== undefined) {
        this._paint(upsellCache[key]);
        return;
      }

      this.hidden = false;
      this.innerHTML = skeleton(popular ? 'Popular right now' : '');

      var url = popular
        ? ROOT + '?sections=jm-cart-upsell'
        : ROOT +
          'recommendations/products?section_id=jm-cart-upsell&product_id=' +
          encodeURIComponent(productId) +
          '&limit=10&intent=related';

      fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error('recommendations ' + res.status);
          return popular
            ? res.json().then(function (j) { return j['jm-cart-upsell'] || ''; })
            : res.text();
        })
        .then(function (html) {
          if (popular) html = html.replace('You may also like', 'Popular right now');
          var box = new DOMParser().parseFromString(html, 'text/html').querySelector('.jmu');
          var out = box ? box.outerHTML : '';
          upsellCache[key] = out;
          if (self.isConnected) self._paint(out);
        })
        .catch(function () {
          if (self.isConnected) self._paint('');
        });
    }

    _paint(html) {
      if (!html || html.indexOf('jmu__card') === -1) {
        this.innerHTML = '';
        this.hidden = true;
        return;
      }
      this.innerHTML = html;
      this.hidden = false;
    }

    _onClick(e) {
      var size = e.target.closest('.jmu__size');
      if (size) return this._pickSize(size);

      var add = e.target.closest('.jmu__add');
      if (add) return this._add(add);

      var nav = e.target.closest('.jmu__nav-btn');
      if (nav) {
        var track = this.querySelector('[data-jmu-track]');
        if (track) {
          track.scrollBy({ left: (nav.getAttribute('data-dir') === 'next' ? 1 : -1) * track.clientWidth * 0.8, behavior: 'smooth' });
        }
      }
    }

    _pickSize(btn) {
      if (btn.disabled) return;
      var card = btn.closest('.jmu__card');
      Array.prototype.forEach.call(card.querySelectorAll('.jmu__size'), function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
      var add = card.querySelector('.jmu__add');
      add.setAttribute('data-variant-id', btn.getAttribute('data-variant-id'));
      add.classList.remove('is-error');
      add.textContent = 'Add to cart';
    }

    _flash(btn, text, ms) {
      var original = btn.getAttribute('data-label') || btn.textContent;
      btn.setAttribute('data-label', original);
      btn.classList.add('is-error');
      btn.textContent = text;
      setTimeout(function () {
        btn.classList.remove('is-error');
        btn.textContent = btn.getAttribute('data-variant-id') ? 'Add to cart' : original;
      }, ms || 1600);
    }

    _add(btn) {
      var self = this;
      var variantId = btn.getAttribute('data-variant-id');

      if (!variantId) {
        var sizes = btn.closest('.jmu__card').querySelector('.jmu__sizes');
        if (sizes) {
          sizes.classList.add('is-nudge');
          setTimeout(function () { sizes.classList.remove('is-nudge'); }, 700);
        }
        this._flash(btn, 'Pick a size!', 1400);
        return;
      }
      if (btn.classList.contains('is-busy') || btn.disabled) return;

      btn.classList.add('is-busy');
      btn.textContent = 'Adding…';

      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: SECTIONS,
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (result) {
          if (!result.ok || result.data.status) {
            throw new Error(result.data.description || result.data.message || 'error');
          }
          var drawer = getDrawer();
          if (drawer && result.data.sections && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents({ sections: result.data.sections });
            updateBadges(countFromSections(result.data.sections));
          } else {
            refreshAndOpen();
          }
        })
        .catch(function () {
          btn.classList.remove('is-busy');
          self._flash(btn, 'Unavailable', 2200);
        });
    }
  }

  if (!customElements.get('jm-cart-upsell')) {
    customElements.define('jm-cart-upsell', JmCartUpsell);
  }
})();
